import FundInformation from './FundInformation'

export default FundInformation
